import type { Infer } from 'superstruct';
import { array, assign, object, optional, partial, string } from 'superstruct';

import { ViewFacebookAdTemplateDto } from '@adflow/shared/data-facebook-ads';

import { historyArrayItem } from '../history-array-item';

import { HistoryFacebookAdCreativeTemplateDto } from './history-facebook-adcreative.dto';

export const HistoryFacebookAdTemplateDto = assign(
	partial(ViewFacebookAdTemplateDto),
	partial(
		object({
			adCreativeTemplates: array(
				historyArrayItem(HistoryFacebookAdCreativeTemplateDto)
			),
			// Only used to distinguish ads on UI
			adName: optional(string()),
		})
	)
);

export type HistoryFacebookAdTemplateDto = Infer<
	typeof HistoryFacebookAdTemplateDto
>;
